import { render } from "./DropWalletComponent.vue?vue&type=template&id=42d65928&scoped=true"
import script from "./DropWalletComponent.vue?vue&type=script&lang=js"
export * from "./DropWalletComponent.vue?vue&type=script&lang=js"

import "./DropWalletComponent.vue?vue&type=style&index=0&id=42d65928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d65928"]])

export default __exports__